import type { GetLeadsParams } from 'services/leadApi'

export const leadQueryKeys = {
  all: ['leads'] as const,
  lists: () => [...leadQueryKeys.all, 'list'] as const,
  list: (filters: GetLeadsParams) => [...leadQueryKeys.lists(), filters] as const,
}
